import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import { notification } from './helpers.js';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons';
import 'datatables.net-rowreorder-bs5';
import { PasswordValidation } from './password_validation.js';



require('./bootstrap');
require('select2');
require('datatables.net-dt');
require('datatables.net-responsive-dt');
require('datatables.net-bs5');
require('pdfmake');


window.JSZip = require('jszip');
window.notification = notification;
window.lang_datatable = lang_datatable();
window.init_validator = init_validator;


export function lang_datatable() {
    var lang = $("html").attr("lang");
    var url_lang = "/js/datatables/datatables-en.json";
    if (lang == "fr") {
        url_lang = "/js/datatables/datatables-fr.json";
    } else if (lang == "es") {
        url_lang = "/js/datatables/datatables-es.json";
    } else if (lang == "pt") {
        url_lang = "/js/datatables/datatables-pt.json";
    }
    return url_lang;
}

export function init_validator(html) {
    html = html === undefined ? "body" : html;
    $('form', html).each(function() {
        $(this).validate();
    });

    //$('input[required]').on('invalid', function() {
    //    this.setCustomValidity("Rempli-moi");
    //});
}

$(function () {
    function init() {
        load_validator();

        init_datatable();
        init_validator();
        init_tab();
        init_pays();
        init_telephone();
        init_select2();
        init_lst_dynamique();
        init_changement_cooperative();
        init_delete();
        init_notifications();
        init_input_file();
        init_password_validation();
    }

    function init_password_validation() {
        // Main form password validation
        var passwordValidator = new PasswordValidation('password', 'password_confirmation', 'access-form');
        $(document).on("submit", "#access-form", function (e) {   
            e.preventDefault();         
            // Validate password before submitting
            if (!passwordValidator.validatePasswordMatch()) {
                // If validation fails, prevent form submission
                return false;
            }
            // If validation passes, submit the form
            this.submit();
        });
    }

    function init_input_file() {
        var input = $("input[type=file]");
        if (input.length !== 0) {
            $(input).on( "change", function() {
                var filename = input[0].files.length ? input[0].files[0].name : null;
                //var label = $("label[for=fichier]");
                var label = input.prev("label");
                label.html(filename ?? label.data("defaut"));
            });
        }
    }

    function init_tab() {
        if ($('a[data-bs-toggle="pill"]').length > 0) {
            var tabElms = document.querySelectorAll('a[data-bs-toggle="pill"]');
            tabElms.forEach(function (tabElm) {
                tabElm.addEventListener('shown.bs.tab', function (event) {
                    if (($.fn.dataTable.tables(true)).length > 0) {
                        $($.fn.dataTable.tables(true)).DataTable().columns.adjust().responsive.recalc();
                    }
                });
            });
        }

        if ($('a[data-bs-toggle="wizard"]').length > 0) {
            var tabElms = document.querySelectorAll('a[data-bs-toggle="wizard"]');
            tabElms.forEach(function (tabElm) {
                tabElm.addEventListener('shown.bs.tab', function (event) {
                    if (($.fn.dataTable.tables(true)).length > 0) {
                        $($.fn.dataTable.tables(true)).DataTable().columns.adjust().responsive.recalc();
                    }
                });
            });
        }
    }

    function init_select2() {
        if ($(".select2").length > 0) {
            $('.select2').not('.modal .select2').select2({
                placeholder: 'Select an option',
                theme: "bootstrap-5",
            });
        }

        $('.modal')
            .off('shown.bs.modal.select2')
            .on('shown.bs.modal.select2', function () {
                const $modal = $(this);
                const $selects = $modal.find('.select2');

                if ($selects.length > 0) {
                    $selects.each(function () {
                        const $select = $(this);

                        if ($select.hasClass('select2-hidden-accessible')) {
                            $select.select2('destroy');
                        }

                        $select.select2({
                            placeholder: '-',
                            theme: "bootstrap-5",
                            dropdownParent: $modal,
                            width: '100%',
                        });
                    });
                }
            });
    }

    function init_changement_cooperative() {
        $(document).on("change", "#session_cooperative", function (e) {
            document.getElementById('sessionCooperativeForm').submit();
        });
    }

    function init_delete() {
        if ($(".btn-delete").length > 0) {
            $(document).on("click", ".btn-delete", function (e) {
                event.preventDefault();
                var result = confirm("Souhaitez-vous vraiment supprimer cet élément?");
                if (result === true) {
                    document.getElementById('deleteForm').submit();
                }
            });
        }
        if ($(".btn-delete2").length > 0) {
            $(document).on("click", ".btn-delete2", function (e) {
                event.preventDefault();
                var result = confirm("Souhaitez-vous vraiment supprimer cet élément?");
                if (result === true) {
                    document.getElementById('deleteForm2').submit();
                }
            });
        }
    }

    function load_validator() {
        var lang = $("html").attr("lang");

        require('jquery-validation');

        if (lang == "fr") {
            require('jquery-validation/dist/localization/messages_fr');
        } else if (lang == "es") {
            require('jquery-validation/dist/localization/messages_es');
        }
    }

    function init_datatable() {
        if ($('.datatable').length > 0) {
            var datatable = $('.datatable').DataTable({
                "bProcessing": true,
                "deferRender": true,
                "destroy": true,
                "order": [],
                "pageLength": 25,
                "scrollX": true,
                "lengthMenu": [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                "responsive": true,
                "language": {
                    "url": lang_datatable()
                }
            });
        }
        if ($('.datatable-sm').length > 0) {
            var datatable = $('.datatable-sm').DataTable({
                "bProcessing": true,
                "deferRender": true,
                "destroy": true,
                "order": [],
                "pageLength": 5,
                "scrollX": true,
                "lengthMenu": [[5, 25, 50, 100, -1], [5, 25, 50, 100, "All"]],
                "responsive": true,
                "language": {
                    "url": lang_datatable()
                }
            });
        }
    }

    function init_telephone() {
        if ($(".telephone").length > 0) {
            const input = document.querySelector(".telephone");
            var tel = intlTelInput(input, {
                autoPlaceholder: "aggressive",
                preferredCountries: ["CA", "CO", "CI"]
            });
        }
    }

    function init_pays() {
        if ($("#pays_id").length > 0) {
            var pays_id = $("#pays_id").val();
            chargement_province(pays_id);
            $(document).on("change", "#pays_id", function (e) {
                var pays_id = $(this).val();
                chargement_province(pays_id);
            });
        }
    }

    function chargement_province(pays_id) {
        if ($("#province_id").length > 0) {
            var province = $("#province_id").attr("data-value");
            $.ajax({
                url: "/province_lst",
                method: 'POST',
                dataType: "json",
                data: {
                    "_token": $('meta[name=csrf-token]').attr("content"),
                    "pays_id": pays_id
                },
                success: function (data) {
                    $('#province_id').empty();
                    for (var i in data) {
                        $("#province_id").append("<option value='" + data[i].id + "'>" + data[i].nom + "</option>");
                    }
                    $('#province_id').val(province);
                }
            });
        }
    }

    function init_notifications() {
        $(document).on("click", ".notifications_lu", function (e) {
            event.preventDefault();
            $.ajax({
                url: route('notifications_lu'),
                method: 'POST',
                data: {
                    "_token": $('meta[name=csrf-token]').attr("content")
                },
                success: function (data) {
                    //console.log("Notification lu");
                }
            });
        });
    }

    function init_lst_dynamique() {
        if ($(".dynamic-select").length > 0) {
            $(document).on('change', '.dynamic-select', function () {
                var champ_id = $(this).attr("data-id");
                var option_id = $(this).val();
                chargement_lst_valeurs_dynamique(champ_id, option_id);
            });

            $(".modal").each(function () {
                this.addEventListener('show.bs.modal', function (event) {
                    chargement_lst_dynamique();
                });
            });

            chargement_lst_dynamique();
        }
    }

    function chargement_lst_dynamique() {
        $(".dynamic-select").each(function () {
            var champ_id = $(this).attr("data-id");
            var option_id = $(this).val();
            chargement_lst_dynamique_valeurs(champ_id, option_id);
        });
    }

    function chargement_lst_dynamique_valeurs(champ_id, option_id) {
        $.ajax({
            url: route('get_champ_conditions'),
            method: 'POST',
            data: {
                "_token": $('meta[name=csrf-token]').attr("content"),
                "champ_id": champ_id,
                "option_id": option_id
            },
            success: function (data) {
                //console.log('data');
                //console.log(data);
                $.each(data, function (i, item) {
                    $('select[name="champ[' + i + ']"]').html("");
                    $.each(data[i], function (a, option) {
                        $('select[name="champ[' + i + ']"]').append($('<option>', {
                            value: a,
                            text: option
                        }));
                    });
                });
            }
        });
    }
    init();
});
